import { UsStateData } from '../address-form-types';

export const filterUsStates = (usStates: UsStateData[] | null | undefined): UsStateData[] => {
  if (!usStates || !Array.isArray(usStates)) {
    return [];
  }
  return usStates.filter((state) => state.display_indicator);
};
